import { render } from "./SceneLoading.vue?vue&type=template&id=22028be0&scoped=true"
const script = {}

import "./SceneLoading.vue?vue&type=style&index=0&id=22028be0&scoped=true&lang=css"

import exportComponent from "/var/www/html/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22028be0"]])

export default __exports__